import { render, staticRenderFns } from "./UiDiscord.vue?vue&type=template&id=4816e6b3"
import script from "./UiDiscord.vue?vue&type=script&lang=js"
export * from "./UiDiscord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports